/**
 * @module app.shared
 */

/**
 * @enum
 * An enum of common keys used in event handlers.
 */
export enum Key {
    Left = 'ArrowLeft',
    Up = 'ArrowUp',
    Right = 'ArrowRight',
    Down = 'ArrowDown',
    Backspace = 'Backspace',
    Delete = 'Delete',
    Esc = 'Escape',
    Enter = 'Enter',
    PageUp = 'PageUp',
    PageDown = 'PageDown',
    Space = 'Space',
    Tab = 'Tab',
    Shift = 'Shift',
    Home = 'Home',
    End = 'End'
}

/**
 * @internal
 * A map of known KeyboardEvent.code values to Keys.
 */
const map = new Map<string, Key>([
    ['ArrowLeft', Key.Left],
    ['ArrowUp', Key.Up],
    ['ArrowRight', Key.Right],
    ['ArrowDown', Key.Down],
    ['Backspace', Key.Backspace],
    ['Delete', Key.Delete],
    ['Escape', Key.Esc],
    ['Enter', Key.Enter],
    ['NumpadEnter', Key.Enter],
    ['PageUp', Key.PageUp],
    ['PageDown', Key.PageDown],
    ['Space', Key.Space],
    ['Tab', Key.Tab],
    ['Shift', Key.Shift],
    ['Home', Key.Home],
    ['End', Key.End]
]);

/**
 * Translates a KeyboardEvent to a Key.
 * @param {KeyboardEvent} event - The event from which to read the Key.
 * @returns {Key | undefined} The Key, or undefined if no known Key found.
 */
export function getKey({ code }: KeyboardEvent): Key | undefined {
    return map.get(code);
}

export function getChar({ key }: KeyboardEvent): string | null {
    return /^[a-z0-9 _-]$/i.test(key) ? key : null;
}
